import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchExerciseMin } from "../../../redux/slices/optionsSlice";

import {
  addNewExercise,
  clearMessage,
  fetchExercisesForDayAndWeek,
} from "../../../redux/slices/customer/trainingSlice";

const AddExerciseModal = ({ isOpen, onClose, selectedExerciseParent, week_number, day_number }) => {
  const dispatch = useDispatch();
  const exercises_min = useSelector((state) => state.app_options?.exercises_min);
  const [selectedExercise, setSelectedExercise] = useState(null);
  const [exercisesData, setExercisesData] = useState([]);

  useEffect(() => {
    if (Array.isArray(exercises_min)) {
      setExercisesData(exercises_min);
    }
  }, [exercises_min]);

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchExerciseMin({ searchTerm: "", old_exercise_id: selectedExerciseParent }));
    } else {
      setSelectedExercise(null);
      setExercisesData([]);
    }
  }, [isOpen, dispatch, selectedExerciseParent]);

  const handleSave = (e) => {
    e.preventDefault();
    if (selectedExercise) {
      const payload = {
        id: selectedExercise,
        week_number,
        day_number
      };
      dispatch(addNewExercise(payload));
      onClose();
    }
  };

  return isOpen ? (
    <div className="modal fade show replace-exercise-modal" style={{ display: "block" }} aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">Add Exercise</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSave}>
              <div className="w-100 mt-4">
                <label className="inputLabel mb-2" htmlFor="exercise-select">
                  Select Exercise
                </label>
                <select
                  id="exercise-select"
                  className="form-control"
                  value={selectedExercise || ""}
                  onChange={(e) => setSelectedExercise(e.target.value)}
                >
                  <option value="">-- Select an Exercise --</option>
                  {exercisesData.map((exercise) => (
                    <option key={exercise.id} value={exercise.id}>
                      {exercise.training_name} ({exercise.category_name_display})
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group mb-0 mt-4">
                <button type="submit" className="btn-curve w-100" disabled={!selectedExercise}>
                  Add Exercise
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default AddExerciseModal;
